import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

let mySwiperIndex;

export function sliderControlBtn() {
  const sliderBtnAll = document.querySelectorAll('.js-sliderBtn');
  const IS_PAUSE = 'is-pause';

  sliderBtnAll.forEach((sliderBtn, index) => {
    sliderBtn.addEventListener('click', () => {
      const popSliderAll = document.querySelectorAll('.js-popSlider');

      sliderControlBtnAction(sliderBtn, mySwiperIndex);
      // if (popSliderAll.length > 1) {
      //   console.log('true');
      //   sliderControlBtnAction(sliderBtn, mySwiperIndex[index]);
      // } else {
      //   console.log('false');
      // }
    });
  });

  function sliderControlBtnAction(thisSelectedBtn, thisTargetSlider) {
    if (thisSelectedBtn.classList.contains(IS_PAUSE)) {
      thisSelectedBtn.classList.remove(IS_PAUSE);
      thisTargetSlider.autoplay.start();
    } else {
      thisSelectedBtn.classList.add(IS_PAUSE);
      thisTargetSlider.autoplay.stop();
    }
  }
}

export function indexSwiper() {
  const companySlide01 = document.querySelector('.js-companySlide01');
  const companySlide02 = document.querySelector('.js-companySlide02');
  const popSliderAll = document.querySelectorAll('.js-popSlider');

  // sliderCreate(companySlide01);
  // sliderCreate(companySlide02);

  // function sliderCreate(ele) {

  popSliderAll.forEach((target, index) => {
    const thisSliderNavPrev = target.parentNode.querySelector('.js-swiperNavPrev');
    const thisSliderNavNext = target.parentNode.querySelector('.js-swiperNavNext');
    const thisSliderPager = target.parentNode.querySelector('.js-swiperPager');

    mySwiperIndex = new Swiper(target, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      loop: true,
      spaceBetween: 20,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: thisSliderNavNext,
        prevEl: thisSliderNavPrev,
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 64,
        },
      },
      pagination: {
        el: thisSliderPager,
        clickable: true,
        renderBullet: function (index, className) {
          return '<button class="' + className + '"></button>';
        },
      },
    });
  });

  // }
}
